const INTEGRATION_TYPE = {
    AGENTLESS: 'AGENTLESS',
    AGENT_BASED: 'AGENT_BASED',
};

export default INTEGRATION_TYPE;
